import { render, staticRenderFns } from "./wsEditorRegular.vue?vue&type=template&id=5e3e1872&scoped=true&"
import script from "./wsEditorRegular.vue?vue&type=script&lang=js&"
export * from "./wsEditorRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e1872",
  null
  
)

export default component.exports